// Page Builder 2026 — Video block
//
// Swaps the cover image for the real player on click. Everything needed is carried
// on the element itself rather than looked up by id, so the same video can appear
// more than once on a page without the wrong one opening.
//
// The --cover class is dropped on play purely to clear the pointer cursor. The
// Frame Style shape is deliberately not tied to it — the angled clip-path stays on
// through playback.

document.addEventListener('click', (event) => {
  const trigger = event.target.closest('.block-video__play');

  if (!trigger) {
    return;
  }

  const media = trigger.closest('.block-video__media');

  if (!media) {
    return;
  }

  const embedUrl = media.dataset.videoEmbed;
  const video = media.querySelector('video');

  media.classList.remove('block-video__media--cover');

  // Uploaded file: the player is already in the markup behind the cover.
  if (!embedUrl && video) {
    const cover = media.querySelector('.block-video__poster');

    if (cover) {
      cover.remove();
    }

    trigger.remove();
    video.play();

    return;
  }

  if (!embedUrl) {
    return;
  }

  const iframe = document.createElement('iframe');

  iframe.setAttribute('src', embedUrl);
  iframe.setAttribute('title', 'Video');
  iframe.setAttribute('frameborder', '0');
  iframe.setAttribute(
    'allow',
    'accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture'
  );
  iframe.setAttribute('allowfullscreen', '');

  media.innerHTML = '';
  media.appendChild(iframe);
});
